<div class="setnew-root">
  <div class="setnew-columns">
    <div class="setnew-image-col" aria-hidden="true">
      <app-auth-hero-panel [hero]="hero" />
    </div>
    <!-- Right: Create Password Form -->
    <div class="setnew-form-col">
      <div class="setnew-form-wrapper">
        <div class="logo-container">
          <img src="assets/icons/aio-logo-black.svg" alt="Logo" class="setnew-logo" />
        </div>
        <h2 class="setnew-title">Create Password</h2>
        <div class="setnew-subtext">Must be at least 8 characters long with one special character and uppercase letter</div>

        <!-- Loading State -->
        @if (loading()) {
          <div class="loading-message">
            <span>Validating activation link...</span>
          </div>
        }

        <!-- Token Error State -->
        @if (tokenError()) {
          <div class="token-error">
            <div>{{ tokenError() }}</div>
          </div>
        }

        <!-- Request New Activation Link Button (outside error box) -->
        @if (tokenError()) {
          <div class="request-link-container">
            <button
              type="button"
              (click)="requestNewLink()"
              class="request-link-button">
              Request New Activation Link
            </button>
          </div>
        }

        <!-- Submit Error State -->
        @if (submitError()) {
          <div class="submit-error">
            {{ submitError() }}
          </div>
        }

        <!-- Password Form (only show if token is valid) -->
        @if (tokenValid()) {
          <form [formGroup]="passwordForm" class="setnew-form" (ngSubmit)="onSubmit()">
          <div class="form-group">
            <label for="password" class="form-label">New Password</label>
            <div class="input-icon-group">
              <input id="password" type="{{passwordVisible() ? 'text' : 'password'}}" class="form-input" [class.input-error]="isPasswordError()" placeholder="New Password" formControlName="password" (input)="onPasswordChange()" (blur)="onPasswordBlur()" />
              <span class="input-icon eye-icon" [class.eye-open]="passwordVisible()" (click)="passwordVisible.set(!passwordVisible())" tabindex="0" role="button" aria-label="Show/Hide password"></span>
            </div>
            <div class="password-strength-label">Password Strength:</div>
            <div class="password-strength-bar">
              <div class="bar" [class.filled]="passwordStrength() >= 1" [class.red]="passwordStrength() === 1" [class.yellow]="passwordStrength() === 2" [class.green]="passwordStrength() === 3"></div>
              <div class="bar" [class.filled]="passwordStrength() >= 2" [class.yellow]="passwordStrength() === 2" [class.green]="passwordStrength() === 3"></div>
              <div class="bar" [class.filled]="passwordStrength() >= 3" [class.green]="passwordStrength() === 3"></div>
            </div>
          </div>
          <div class="form-group">
            <label for="confirmPassword" class="form-label">Confirm Password</label>
            <div class="input-icon-group">
              <input id="confirmPassword" type="{{confirmPasswordVisible() ? 'text' : 'password'}}" class="form-input" [class.input-error]="isConfirmPasswordError()" placeholder="Confirm New Password" formControlName="confirmPassword" />
              <span class="input-icon eye-icon" [class.eye-open]="confirmPasswordVisible()" (click)="confirmPasswordVisible.set(!confirmPasswordVisible())" tabindex="0" role="button" aria-label="Show/Hide password"></span>
            </div>
            @if (showSpecialCharError() && (!hasSpecialCharacter() || !hasUppercaseLetter())) {
              <div class="field-error">
                Allowed special characters: !&#64;#$%^&
              </div>
            }
            @if (confirmPassword() && password() !== confirmPassword()) {
              <div class="field-error">
                Passwords do not match
              </div>
            }
          </div>
          <aio-button [block]="true" appearance="brand" size="lg"
            type="submit"
            [disabled]="!canSubmit() || loading()"
            class="setnew-button">
            @if (loading()) {
              <span>Creating Password...</span>
            }
            @if (!loading()) {
              <span>Create Password</span>
            }
          </aio-button>
          <aio-button [block]="true" appearance="neutral-stroke" size="lg" type="button" class="back-to-login-button" (pressed)="goBack()">
            <svg class="back-arrow-icon" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
              <path d="M19 12H5"/>
              <path d="m12 19-7-7 7-7"/>
            </svg>
            Back to Login
          </aio-button>
        </form>
        }
        <app-auth-footer></app-auth-footer>
      </div>
    </div>
  </div>
</div>
